export const reduxKey = '@@WHO';
export const streamType = '@@WHO';
export const actionKey = '@@WHO';

//# sourceMappingURL=constants.js.map